/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Product_Buy_Note1Inputs */

const vi_sitesettings_product_buy_note1 = /** @type {(inputs: Sitesettings_Product_Buy_Note1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dòng dưới nút Mua ngay (vd "Giao tận nơi · COD hoặc quét QR")`)
};

/**

* @param {Sitesettings_Product_Buy_Note1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_product_buy_note1 = /** @type {((inputs?: Sitesettings_Product_Buy_Note1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Product_Buy_Note1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_product_buy_note1(inputs)
});
export { sitesettings_product_buy_note1 as "siteSettings_product_buy_note" }